import { FONT_STYLE } from '../groups.js';

var emDOM = ['em'];
var em = {
    inclusive: true,
    group: FONT_STYLE,
    parseDOM: [{ tag: 'i' }, { tag: 'em' }, { style: 'font-style=italic' }],
    toDOM: function () {
        return emDOM;
    },
};

export { em };



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/node_modules/@atlaskit/adf-schema/dist/esm/schema/marks/em.js